import Activity from "../model/Activity";
import { addPresentation } from "./presentation";

export default addPresentation(Activity, {
  canAdd: false,
  canEdit: false,
  canRemove: false,
  columns: [],
});
